module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "smartbrain-face-detection.34cc7675.png" + "?" + Date.now();